import { Component } from 'react';
import { Col,Row } from 'reactstrap';
import{FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faLinkedin, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'


export class FooterLinks extends Component {

  render () {


    return (
    <div>
       
        <hr class="mb-3"/>
        <div class="m-3 pt-5">
            <Row>
                <Col sm="5 p-0" >
                    <div class="col-lg-10">
                        <div class="border border-secondary pt-1">
                            <img src="https://www.eni-ecole.fr/wp-content/uploads/2021/05/LogoQualiopi-72dpi-Avec-Marianne.png" alt="Qualiopi" title="LogoQualiopi-72dpi-Avec-Marianne" />
                            <div class="d-flex flex-column color-darker-blue-eni openSans fs-11 p-3 pt-0 lh-22">
                                <span class="fst-italic">La certification qualité a été délivrée<br/> au titre de la catégorie d’action suivante :</span>
                                <span>ACTIONS DE FORMATION </span>
                                <span>VALIDATION DES ACQUIS DE L’EXPERIENCE</span>
                                <span>ACTIONS DE FORMATION PAR APPRENTISSAGE</span>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <span class="color-blue-light-eni fw-semibold fs-14">Suivez-nous</span>
                        <div class="color-blue-light-eni d-flex align-content-start">
                            <a class="px-2 pl-0 pt-1 color-blue-light-eni" href="https://www.facebook.com/EniEcoleInformatique/"><FontAwesomeIcon icon={faFacebook} size="2x"/></a>
                            <a class="px-2 pt-1 color-blue-light-eni" href="https://www.linkedin.com/school/eni-ecole-informatique/"><FontAwesomeIcon icon={faLinkedin} size="2x"/></a>
                            <a class="px-2 pt-1 color-blue-light-eni" href="https://twitter.com/ENIEcoleInforma"><FontAwesomeIcon icon={faTwitter} size="2x"/></a>
                            <a class="px-2 pt-1 color-blue-light-eni" href="https://www.youtube.com/channel/UCFAgWQHt47WvO63FK72vGVg"><FontAwesomeIcon icon={faYoutube} size="2x"/></a>
                            <a class="px-2 pt-1 color-blue-light-eni" href="https://www.instagram.com/eniecoleinformatique/"><FontAwesomeIcon icon={faInstagram} size="2x"/></a>
                        </div>
                    </div>
                </Col>
                <Col sm="3">
                    <h1 class="color-blue-light-eni fw-semibold fs-14">Nous connaître</h1>
                    <div class="lh-28">
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.eni-ecole.fr/formations/formations-eni/" target="_blank" rel="noopener noreferrer">Nos formations</a><br/>
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.eni-ecole.fr/rejoindre-lecole/candidatez/" target="_blank" rel="noopener noreferrer">Je candidate</a><br/>
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.eni-ecole.fr/faq/" target="_blank" rel="noopener noreferrer">Questions fréquentes</a><br/>
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.eni-ecole.fr/rejoindre-lecole/contact/" target="_blank" rel="noopener noreferrer">Contact</a><br/>
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.eni-ecole.fr/groupe-eni/" target="_blank" rel="noopener noreferrer">Le Groupe ENI</a><br/>
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.editions-eni.fr/blog/" target="_blank" rel="noopener noreferrer">Le Blog ENI</a><br/>
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.eni-ecole.fr/mentions-legales-et-protection-des-donnees/" target="_blank" rel="noopener noreferrer">Mentions légales et protection des données</a><br/>
                        <a class="text-decoration-none text-reset color-darker-blue-eni openSans fs-14" href="https://www.eni-ecole.fr/conditions-generales-de-prestations-de-formation/" target="_blank" rel="noopener noreferrer">Conditions générales</a>
                    </div>
                </Col>
                <Col sm="4">
                   
                    <h1 class="color-blue-light-eni fw-semibold fs-14">Nos informations</h1>
                    <div class="openSans fs-14 color-darker-blue-eni lh-28">
                        <div class="mb-3">
                            <span>ZAC du Moulin Neuf - 2 B, rue Benjamin Franklin</span><br/>
                            <span class="fs-14">BP 80009 - 44801 Saint-Herblain</span>
                        </div>        
                        <p>Tél. 02 28 03 17 28</p>
                        <div class="mt-2">
                            <span>ENI Ecole - RCS Nantes : 392 807 061</span><br/>
                            <span >Non assujetti à la TVA - Capital Social : 40 000 € </span>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
    );
  }
}
